import React from 'react';
import { useIntl } from 'react-intl';
import { LeaveFeedbackButton } from '../leave-feedback-button';

interface Props {
  className?: string;
  isLeaveFeedbackVisible?: boolean;
}

export const DashboardSidebarFooter: React.FC<Props> = ({
  className,
  isLeaveFeedbackVisible,
}) => {
  const { formatMessage } = useIntl();

  return (
    <footer className={`dashboard__sidebar__footer ${className || ''}`}>
      {isLeaveFeedbackVisible && (
        <>
          <div className="divider--verylight-5 u-width--full s-bottom--med" />
          <LeaveFeedbackButton className="u-width--full" />
        </>
      )}
      <div className="f f--align-center f--justify-between u-width--full">
        <a
          className="logo__link"
          href={formatMessage({
            id: 'routes.home',
          })}
          rel="noreferrer"
          data-cy="sidebar-logo-link-footer"
        >
          <svg
            width="63"
            height="16"
            viewBox="0 0 63 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.6" clipPath="url(#clip0_14794_158266)">
              <mask
                id="mask0_14794_158266"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="63"
                height="16"
              >
                <path d="M62.0155 0H0V15.9887H62.0155V0Z" fill="white" />
              </mask>
              <g mask="url(#mask0_14794_158266)">
                <path
                  d="M11.5421 4.93538C11.5421 2.38097 9.72887 0 6.35448 0C2.98015 0 0.725327 2.4125 0 4.99846C1.86062 5.45573 3.10629 7.14288 2.44404 9.17699L1.13529 13.2293H3.34282L4.2829 10.3949C4.71321 10.4931 5.18294 10.5645 5.67648 10.5645C8.53048 10.5645 11.5421 8.21513 11.5421 4.93538ZM4.25736 3.81585L3.78858 5.17458C3.52856 4.63626 3.16354 4.27518 2.73669 4.00255C3.22266 3.18671 4.42324 2.08138 6.21259 2.08138C8.18357 2.08138 9.30313 3.43742 9.30313 4.90385C9.30313 6.79603 7.45823 8.43584 5.69224 8.43584C5.45115 8.43584 5.20706 8.40384 4.95967 8.35454L6.46487 3.81585H4.25736Z"
                  fill="#B9B9B9"
                />
                <path
                  d="M49.4481 11.2267L53.1066 7.34778L53.5638 5.34522H47.4932C47.2105 6.5004 46.4394 7.0808 45.4561 7.28074C44.8517 5.95702 43.5483 5.09293 41.9271 5.09293C40.5349 5.09293 39.2894 5.72933 38.4703 6.73042C37.8856 7.44521 37.2113 8.08161 36.4764 8.64074L36.296 8.77792C36.2159 6.43448 34.4064 5.09293 32.8132 5.09293C32.1071 5.09293 31.3263 5.36099 30.6249 5.84113L30.7791 5.34522H29.1235L28.5228 7.20471L26.4115 8.80849C26.3127 6.66139 24.707 5.09293 22.5323 5.09293C21.2905 5.09293 20.1657 5.59924 19.3558 6.41916C18.9528 6.8271 18.5146 7.19876 18.0543 7.54059L16.9695 8.34666L17.25 7.17414C17.5023 6.08616 16.8085 5.09277 15.689 5.09277C15.1298 5.09277 14.4963 5.34097 13.9203 5.88071L14.0964 5.34506H12.3619L9.8233 13.2291H11.952L13.6549 7.96254C13.7968 7.52105 14.1122 7.17414 14.5064 7.17414C14.9479 7.17414 15.1686 7.63144 14.9952 8.18332L14.7114 9.06629C14.3803 10.0755 15.0425 10.8796 15.9728 10.8796C16.3197 10.8796 16.7454 10.785 17.2185 10.4224L18.076 9.78691C18.1857 11.9375 19.8188 13.4814 21.9962 13.4814C23.4311 13.4814 24.3298 12.8191 25.2759 12.078L27.5243 10.2961L25.6859 15.9885H27.8146L29.1124 11.9784C29.6561 12.8404 30.5646 13.4814 31.867 13.4814C33.1692 13.4814 34.106 12.8664 35.0048 12.1726L37.5132 10.2117C37.8023 12.1379 39.3597 13.4814 41.3908 13.4814C43.7803 13.4814 45.7084 11.5916 45.8165 9.22859C47.2205 8.984 48.0487 8.26338 48.7229 7.3476H50.365L46.6889 11.2265L46.2316 13.2291H51.5303C52.4429 13.2291 53.333 12.9459 54.0779 12.4184L54.4842 12.1308C55.1493 12.9284 56.1804 13.4814 57.6161 13.4814C59.6343 13.4814 61.1166 12.3934 62.0153 11.4157L60.675 9.94933C59.8236 10.7535 58.9879 11.4 57.8999 11.4C57.4111 11.4 56.9757 11.2639 56.6271 11.0225L61.8077 8.16484C61.1297 6.46189 59.7447 5.09277 57.8526 5.09277C55.6135 5.09277 53.5479 7.01649 53.5479 9.44471C53.5479 9.76515 53.5831 10.0907 53.6544 10.411C52.9082 10.9415 52.0153 11.2265 51.0996 11.2265H49.4478L49.4481 11.2267ZM22.1225 11.4001C21.0345 11.4001 20.2776 10.5802 20.2776 9.42915C20.2776 8.15194 21.2079 7.17432 22.3906 7.17432C23.4785 7.17432 24.2196 7.99423 24.2196 9.1453C24.2196 10.4068 23.3051 11.4001 22.1225 11.4001ZM31.9932 11.4001C30.9052 11.4001 30.1484 10.5802 30.1484 9.42915C30.1484 8.15194 31.0787 7.17432 32.2613 7.17432C33.3493 7.17432 34.0904 7.99423 34.0904 9.1453C34.0904 10.4068 33.1759 11.4001 31.9932 11.4001ZM41.5171 11.4001C40.4291 11.4001 39.6722 10.5802 39.6722 9.42915C39.6722 8.15194 40.6026 7.17432 41.7852 7.17432C42.8732 7.17432 43.6143 7.99423 43.6143 9.1453C43.6143 10.4068 42.6997 11.4001 41.5171 11.4001ZM57.6951 7.07969C58.2077 7.07969 58.5741 7.26232 58.9122 7.64893L55.7581 9.3716C55.7564 9.33339 55.7556 9.29476 55.7556 9.25581C55.7556 7.99442 56.6228 7.07987 57.6951 7.07987V7.07969Z"
                  fill="#B9B9B9"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_14794_158266">
                <rect width="62.0155" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </a>
        <span className="t-text-3 dashboard__sidebar__footer__version">
          Version: {process.env.GATSBY_APP_VERSION?.split('-')[0]}
        </span>
      </div>
    </footer>
  );
};
